import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import './index.css'
import * as firebase from 'firebase'

// Initialize Firebase
var config = {
  apiKey: 'AIzaSyAALoqaldD3eYhUvoqSrh_NjV1Ai8iDypg',
  authDomain: 'frixr-dev.firebaseapp.com',
  databaseURL: 'https://frixr-dev.firebaseio.com',
  storageBucket: 'frixr-dev.appspot.com',
  messagingSenderId: '544566481815'
}
firebase.initializeApp(config)

ReactDOM.render(
  <App />,
  document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js